import React from 'react';
import type IssueDetail from '@atlassian/jira-spa-apps-admin-pages-performance-issue/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyIssueDetail = lazyForPaint<typeof IssueDetail>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-system-performance-metric-detail", jiraSpaEntry: "async-system-performance-issue" */ '@atlassian/jira-spa-apps-admin-pages-performance-issue'
		),
	),
);

export const IssueMetricDetail = () => (
	<LazyPage
		Page={LazyIssueDetail}
		pageId="system-performance-metric-detail-issue"
		shouldShowSpinner
	/>
);
